<template>
    <div class="ts-app-shell_fh">
        <div ref="container" class="padd-main">
            <el-row class="narrow">
                <el-col :xl="22" :lg="22" :md="22" :sm="22" :xs="22">
                    <h5 class="dashboard-title"><strong>My Referent Status</strong></h5>
                </el-col>
            </el-row>
            <el-row class="narrow">
                <el-col class="dashboard-paragraph">
                <p> Here you can see all the referrals that you were in. Please update the status to Hired / Rejected once you received the acceptance for the role if necessary.</p>
                </el-col>
            </el-row>
            <el-divider></el-divider>

            <input type="hidden" :value="(this.windowWidth, this.windowHeight, this.tableHeight)">

            <el-table
                :data="tableData.filter(data => !search || data.jobSeekerName.toLowerCase().includes(search.toLowerCase()) 
                || data.organisationName.toLowerCase().includes(search.toLowerCase())
                || data.vacantRoleTitle.toLowerCase().includes(search.toLowerCase()))"
                style="width: 100%"
                v-if="!showNoData"
                :height="tableHeight">
                <el-table-column sortable show-overflow-tooltip width="250" :label="$t('uorganization') + ' Name'" prop="organisationName"></el-table-column>
                <el-table-column sortable show-overflow-tooltip width="220" label="Job Role" prop="vacantRoleTitle"></el-table-column>
                <el-table-column sortable show-overflow-tooltip width="220" label="Job Seeker" prop="jobSeekerName"></el-table-column>
                <el-table-column sortable show-overflow-tooltip width="180" label="Date Hired">
                    <template slot-scope="scope">
                        {{ scope.row.DateHired | moment('MMMM DD, YYYY') }}
                    </template>
                </el-table-column>
                <el-table-column sortable width="180" label="Status">
                    <template slot-scope="scope">
                        <el-select 
                            v-if="scope.row.status === 0 || scope.row.status === 1"
                            :disabled="scope.row.isOrganisationRegistered"
                            v-model="scope.row.newStatus" 
                            placeholder="Status" 
                            size="small"
                            style="width: 170px;padding-right: 10px;display:inline-block;" >
                            <el-option
                                v-for="item in statuses"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <span v-else>{{ scope.row.statusName }}</span>                        
                    </template>
                </el-table-column>
                <el-table-column align="left" width="180">
                    <template slot="header" slot-scope="scope">
                        <el-input v-model="search" size="mini" placeholder="Type to search" />
                    </template> 
                    <template slot-scope="scope">
                        <button style="height:34px; width: 100px" class="ts-btn ts-btn-small" :style="scope.row.isOrganisationRegistered == true ? 'display:none;':'display:block;'" v-if="scope.row.status === 0 || scope.row.status === 1" @click="updateStatus(scope.row)">Update</button>
                    </template>                   
                </el-table-column>
            </el-table>
        
            <div v-if="showNoData" class="no-data">
                <div>
                    <span class="fa-stack">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="far fa-folder-open fa-stack-1x fa-inverse"></i>
                    </span>
                <div class="no-data-text">{{ noDataText }}</div>
                </div>
            </div>
        </div>
        <!-- <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="false">
        </loading> -->

        <TSLoading :active="isLoading" :defaultMessage="'Please wait...'" :altMessage="'Please hold on for a moment while we process the data...'"/>
    </div>
</template>

<script>
import TSLoading from '../../../components/TSLoading.vue';

export default {
    components: {
        TSLoading
    },
    created() {
        this.getReferrals();
    },
    data() {
        return {
        windowWidth: 0,
        windowHeight: 0,      
        tableHeight: 0,
        tableData: [],
        search: '',
        showNoData: false,
        noDataText: '',
        isLoading: false,
        statuses: [{
            value: 0,
            label: 'Pending'
        }, {
            value: 1,
            label: 'In Progress'
        }, {
            value: 2,
            label: 'Hired'
        }, {
            value: 3,
            label: 'Rejected'
        }],
        tableHeight: 500,
        }
    },
    mounted() {
        this.$nextTick(function() {
        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);

        //Init
        this.getWindowWidth()
        this.getWindowHeight()
        })
    },
    updated(){
        this.tableHeight = this.windowHeight - 300;
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
        window.removeEventListener('resize', this.getWindowHeight);
    },
    computed: {
        currentUser() {
            return this.$store.state.account.current_user;
        },
    },
    methods: {
        getWindowWidth(event) {
            this.windowWidth = document.documentElement.clientWidth;
        },
        getWindowHeight(event) {
            this.windowHeight = document.documentElement.clientHeight;
        },
        getReferrals() {
            this.isLoading = true;
            this.$store.dispatch('agency/getReferralsByJobSeeker')
                .then((res) => {
                    
                    this.tableData = res.map(c => {
                        return { ...c, newStatus: c.status }
                });
                    this.calculateHeight();
                    this.showNoData = res.length === 0;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.showNoData = true;
                    this.isLoading = false;
                });
        },
        updateStatus(row) {
            row.Status = row.newStatus;
            this.$store.dispatch('agency/updateReferral', row)
                .then(() => {
                    this.$message.success('Referral status is updated');
                    this.getReferrals();
                })
                .catch((res) => {
                    this.$message.error(res);
                });
        },
        calculateHeight() {
            this.tableHeight = window.innerHeight - this.$refs['container'].clientHeight + 400;
        }
    }
}
</script>

<style lang="scss">
.dashboard-title{
    margin-top: 20px;
}
</style>